import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMobileSdkTestAllIssues } from 'src/apps/mobile-sdk/services/MobileSdkDashboardService';
import { IGetMobileSdkTestIssuesParams } from 'src/apps/mobile-sdk/services/MobileSdkDashboardServiceTypes';
import { TMobileSdkTestAllIssuesResult } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { MOBILE_SDK_TEST_ALL_ISSUES } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { IUseTableQueryParams } from 'src/common/types/UseTableQueryParamsType';

interface IUseMobileSdkTestAllIssuesQueryParams extends IUseTableQueryParams {
	testId: string;
}

export const useMobileSdkTestAllIssuesQuery = ({
	testId,
	filters,
	sort,
	page,
	pageSize
}: IUseMobileSdkTestAllIssuesQueryParams): UseQueryResult<TMobileSdkTestAllIssuesResult> => {
	const issuesQuery = useQuery(
		[MOBILE_SDK_TEST_ALL_ISSUES, testId, filters, sort, page, pageSize],
		async (): Promise<TMobileSdkTestAllIssuesResult> =>
			getMobileSdkTestAllIssues({
				testId,
				filterOptions: filters as IGetMobileSdkTestIssuesParams['filterOptions'],
				sort,
				page,
				pageSize
			}),
		{
			refetchOnWindowFocus: 'always'
		}
	);

	return issuesQuery;
};
